import React from 'react'

import { KeyValue } from 'components/KeyValues'

import {
  ADDRESS,
  DATE,
  LINK,
  MULTI_LINE,
  SINGLE_LINE,
} from 'ducks/crm/customFields'
import withSidebarModalPositioning from './withSidebarModalPositioning'

import CustomFieldEditButton from './CustomFieldEditButton'
import CustomFieldValue from './CustomFieldValue'

const EDITABLE_FIELDS = [ADDRESS, DATE, LINK, MULTI_LINE, SINGLE_LINE]
const EXCLUDED_FIELDS = [
  'company_domain',
  'company_logo',
  'company_customFieldName',
  'contact_avatar',
  'contact_first_customFieldName',
  'contact_last_name',
  'contact_email',
]
export default withSidebarModalPositioning(CustomFieldWithMenuPosition)

function CustomFieldWithMenuPosition({
  className,
  customFieldIcon,
  customFieldKey,
  customFieldName,
  customFieldType,
  customFieldValue,
  subjectId,
  offset,
  onOpen,
  openMenu,
  menuRef,
}) {
  if (EXCLUDED_FIELDS.includes(customFieldKey)) return null // These fields are rendered ContactHeaderFields and CompanyFieldHeader

  return (
    <KeyValue
      className={className}
      icon={customFieldIcon}
      singleline={customFieldType === SINGLE_LINE}
      title={customFieldName}
      value={
        <CustomFieldValue
          customFieldType={customFieldType}
          customFieldValue={customFieldValue}
        />
      }
    >
      {EDITABLE_FIELDS.includes(customFieldType) && (
        <CustomFieldEditButton
          customFieldIcon={customFieldIcon}
          customFieldKey={customFieldKey}
          customFieldName={customFieldName}
          customFieldType={customFieldType}
          customFieldValue={customFieldValue}
          doSetMenu={onOpen}
          menuRef={menuRef}
          openMenu={openMenu}
          offset={offset}
          subjectId={subjectId}
        />
      )}
    </KeyValue>
  )
}
